import { actions, getters } from '@utils'
import { append, difference, pluck, propEq } from 'rambda'
import { removeIndex, toggleItem } from '@utils/collections'

export default factType => ({
  props: {
    factTemplate: Object,
    fact: Object,
  },
  data() {
    return {
      canMerge: true,
      isCreating: false,
      itemsDismissed: [],
      factType,
    }
  },
  computed: {
    doesExist() {
      return !!this.fact
    },
    items() {
      return this.fact?.items || []
    },
    itemsChecked() {
      return difference(this.items, this.itemsDismissed)
    },
    labels() {
      return pluck('label', (this.factTemplate.items || []))
    },
    ...getters('factFactory'),
  },
  methods: {
    addItem() {
      if (!this.doesExist) {
        this.create(false)
        return
      }

      const { factory } = this.$store.getters.factTypes
        .find(propEq('value', this.factType))

      this.setItems(append(factory(), this.items))
    },
    check(item) {
      this.itemsDismissed = toggleItem(item, this.itemsDismissed)
    },
    setItems(questionsAnswers) {
      this.$up('fact.items', questionsAnswers)
    },
    setItem(index, value) {
      this.$up(`fact.items.${index}`, value)
    },
    setItemField(index, key, value) {
      this.$up(`fact.items.${index}.${key}`, value)
    },
    removeItem(index) {
      this.setItems(removeIndex(index, this.items))
    },
    create(doFill = false) {
      this.isCreating = true
      this.$emit('create', doFill)
    },
    upsert() {
      if (this.doesExist) return this.recreate()

      this.create(true)
    },
    async recreate() {
      const fact = await this
        .$wrap(this.PATCH_FACT({
          id: this.fact.id,
          $doRecreate: true,

          ...(this.canMerge && this.items.length)
            ? {
              $itemsToMerge: this.items
                .map(item => this.itemsDismissed.includes(item)
                  ? null
                  : item),
            }
            : {},
        }), 'isCreating')

      this.$up('fact', fact)
    },
    ...actions('PATCH_FACT'),
  },
  watch: {
    doesExist(doesExist, doesExistPreviously) {
      if (doesExist && !doesExistPreviously) {
        this.isCreating = false
      }
    },
  },
})
